export default [
  {
    title: '考核月份',
    key: 'reportMonth',
    width: 62
  },
  {
    title: '游戏组',
    key: 'gameName',
    width: 120
  },
  // {
  //   title: '游戏ID',
  //   key: 'gameId'
  // },
  {
    title: '媒体',
    key: 'mediaName'
  },
  {
    title: '30天回款率KPI',
    key: 'thirtyDayKpiStr',
    width: 120
  },
  {
    title: '是否特殊提成',
    key: 'isSpecial'
  },
  {
    title: '更新人',
    key: 'opName'
  },
  {
    title: '更新时间',
    key: 'updateTime',
    width: 114
  },
  {
    title: '操作',
    key: 'control',
    width: 104
  }
]
